import { useEffect, useState } from 'react';

const useIsUsingDarkTheme = () => {
  const [isUsingDarkTheme, setIsUsingDarkTheme] = useState(
    document.documentElement.classList.contains('dark'),
  );

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      const classList = (mutations[0].target as HTMLElement).classList;
      setIsUsingDarkTheme(classList.contains('dark'));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return isUsingDarkTheme;
};

export default useIsUsingDarkTheme;
